import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { Component } from 'react';
import moment from 'moment';
import { Box, Dialog, DialogActions, DialogContent as MuiDialogContent, DialogTitle, FormControl, Grid, IconButton, InputAdornment as MuiInputAdornment, Typography, withStyles } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import { KailonaButton, KailonaDateTimePicker, KailonaTextField } from '@kailona/ui';
import GridColumn from '../lib/GridColumn';
var DialogContent = withStyles({
  root: {
    height: '100%',
    margin: '0 20px 20px 20px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #EAEAEA',
    borderRadius: '5px',
    paddingBottom: '25px'
  }
})(MuiDialogContent);
var InputAdornment = withStyles({
  root: {
    '& p': {
      fontSize: '10px'
    }
  }
})(MuiInputAdornment);

var VitalsEditModal = /*#__PURE__*/function (_Component) {
  _inherits(VitalsEditModal, _Component);

  var _super = _createSuper(VitalsEditModal);

  function VitalsEditModal(props) {
    var _this;

    _classCallCheck(this, VitalsEditModal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function (isOpen) {
      _this.setState({
        isOpen: isOpen
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onConfirm", function () {
      var newVitalsData = {
        date: moment(_this.dateRef.current.value),
        systolicBloodPressure: _this.systolicBloodPressureRef.current.value,
        diastolicBloodPressure: _this.diastolicBloodPressureRef.current.value,
        heartRate: _this.heartRateRef.current.value,
        oxygenSaturation: _this.oxygenSaturationRef.current.value,
        bodyTemperature: _this.bodyTemperatureRef.current.value
      };
      var vitalsData = _this.props.vitalsData;

      _this.props.handleSave(Object.assign({}, vitalsData || {}, newVitalsData));
    });

    _defineProperty(_assertThisInitialized(_this), "getValue", function (text) {
      if (!text || !text.split) {
        return text || '';
      }

      var _text$split = text.split(' '),
          _text$split2 = _slicedToArray(_text$split, 1),
          value = _text$split2[0];

      return value;
    });

    _this.state = {
      isOpen: false
    };
    _this.dateRef = /*#__PURE__*/React.createRef();
    _this.systolicBloodPressureRef = /*#__PURE__*/React.createRef();
    _this.diastolicBloodPressureRef = /*#__PURE__*/React.createRef();
    _this.heartRateRef = /*#__PURE__*/React.createRef();
    _this.oxygenSaturationRef = /*#__PURE__*/React.createRef();
    _this.bodyTemperatureRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(VitalsEditModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _ref = this.props.vitalsData || {},
          date = _ref.date,
          systolicBloodPressure = _ref.systolicBloodPressure,
          diastolicBloodPressure = _ref.diastolicBloodPressure,
          oxygenSaturation = _ref.oxygenSaturation,
          heartRate = _ref.heartRate,
          bodyTemperature = _ref.bodyTemperature;

      return /*#__PURE__*/React.createElement(Dialog, {
        open: this.state.isOpen,
        onClose: function onClose() {
          return _this2.toggleModal(false);
        }
      }, /*#__PURE__*/React.createElement(DialogTitle, null, /*#__PURE__*/React.createElement(Box, {
        display: "flex",
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(Box, {
        flexGrow: 1
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "h3"
      }, t('ehr', this.props.vitalsData ? 'Update Vitals' : 'Add New Vitals'))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(IconButton, {
        onClick: function onClick() {
          return _this2.toggleModal(false);
        }
      }, /*#__PURE__*/React.createElement(CloseIcon, null))))), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(KailonaDateTimePicker, {
        inputRef: this.dateRef,
        id: "date",
        ariaLabel: t('ehr', 'Select Date/Time'),
        defaultValue: date ? moment(date) : null,
        disableFuture: true
      }))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(GridColumn, {
        className: "left-column",
        item: true
      }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(KailonaTextField, {
        inputRef: this.systolicBloodPressureRef,
        id: "systolicBloodPressure",
        className: "kailona-MuiTextField",
        label: t('ehr', 'Systolic Blood Pressure'),
        defaultValue: this.getValue(systolicBloodPressure),
        InputProps: {
          endAdornment: /*#__PURE__*/React.createElement(InputAdornment, null, "mmHg")
        }
      }))), /*#__PURE__*/React.createElement(GridColumn, {
        className: "right-column",
        item: true
      }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(KailonaTextField, {
        inputRef: this.diastolicBloodPressureRef,
        type: "number",
        id: "diastolicBloodPressure",
        className: "kailona-MuiTextField",
        label: t('ehr', 'Diastolic Blood Pressure'),
        defaultValue: this.getValue(diastolicBloodPressure),
        InputProps: {
          endAdornment: /*#__PURE__*/React.createElement(InputAdornment, null, "mmHg")
        }
      })))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(GridColumn, {
        className: "left-column",
        item: true
      }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(KailonaTextField, {
        inputRef: this.heartRateRef,
        type: "number",
        id: "heartRate",
        className: "kailona-MuiTextField",
        label: t('ehr', 'Heart Rate'),
        defaultValue: this.getValue(heartRate),
        InputProps: {
          endAdornment: /*#__PURE__*/React.createElement(InputAdornment, null, "beats/minute")
        }
      }))), /*#__PURE__*/React.createElement(GridColumn, {
        className: "right-column",
        item: true
      }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(KailonaTextField, {
        inputRef: this.bodyTemperatureRef,
        type: "number",
        id: "bodyTemperature",
        className: "kailona-MuiTextField",
        label: t('ehr', 'Body Temperature'),
        defaultValue: this.getValue(bodyTemperature),
        InputProps: {
          endAdornment: /*#__PURE__*/React.createElement(InputAdornment, null, "\xB0C")
        }
      })))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(GridColumn, {
        className: "left-column",
        item: true
      }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(KailonaTextField, {
        inputRef: this.oxygenSaturationRef,
        type: "number",
        id: "oxygenSaturation",
        className: "kailona-MuiTextField",
        label: t('ehr', 'Oxygen Saturation (SpO2)'),
        defaultValue: this.getValue(oxygenSaturation),
        InputProps: {
          endAdornment: /*#__PURE__*/React.createElement(InputAdornment, null, "%")
        }
      })))))), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(KailonaButton, {
        title: t('ehr', 'Cancel'),
        class: "default",
        disabled: this.props.savingVitals,
        onClick: function onClick() {
          return _this2.toggleModal(false);
        }
      }), /*#__PURE__*/React.createElement(KailonaButton, {
        title: t('ehr', 'Confirm'),
        class: "primary",
        disabled: this.props.savingVitals,
        onClick: this.onConfirm,
        loading: this.props.savingVitals
      })));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return VitalsEditModal;
}(Component);

export { VitalsEditModal as default };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DialogContent, "DialogContent", "/home/runner/html/nextcloud/apps/ehr/js/plugins/vitals/src/components/VitalsEditModal.js");
  reactHotLoader.register(InputAdornment, "InputAdornment", "/home/runner/html/nextcloud/apps/ehr/js/plugins/vitals/src/components/VitalsEditModal.js");
  reactHotLoader.register(VitalsEditModal, "VitalsEditModal", "/home/runner/html/nextcloud/apps/ehr/js/plugins/vitals/src/components/VitalsEditModal.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();